import { Component, Input } from '@angular/core';

@Component({
  selector: 'cm-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() title!: string;
  @Input() breadcrumbList!: { label: string; url: string; hidden: boolean }[];
}
